import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Option, ScorecardsResult } from '@recruitee/interview-results-types';

import { ScorecardsItemRowComponent } from './scorecards-item-row/scorecards-item-row.component';

@Component({
  selector: 'rt-interview-result-summary-scorecards-item',
  templateUrl: 'interview-result-summary-scorecards-item.component.html',
  styleUrls: ['./interview-result-summary-scorecards-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScorecardsItemRowComponent, TranslatePipe],
})
export class InterviewResultSummaryScorecardsItemComponent {
  @Input() public scorecardsResult: ScorecardsResult;

  public trackByTitle(index: number, item: Option): string {
    return item.title;
  }
}
